module.exports = __webpack_public_path__ + "static/media/relearnText.223e3674.png";